module.exports = "https://static.wmbcdn.com/uniweb/images/1b1040e949a0edb99c6621aa0354b00a.svg";